import React from 'react';
import ReactDOM from 'react-dom/client';
import Navbar from './components/Navbar';
import './index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Register from './components/Register';
import App from './App';
// import reportWebVitals from './reportWebVitals';

/*export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />}>
         <Route path="navbar" element={myelement} />
        </Route>
         <Route path="/login" element={<Login />} />
         <Route path="/register" element={<Register />} />
      </Routes>
    </BrowserRouter>
  );
}
;*/



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
